import React, { Component } from 'react';
import BlogForm from './BlogForm';

export class CreateBlog extends Component {
    static displayName = CreateBlog.name;

    render() {
        return (
            <BlogForm blogId='0' formType='Create' />
        );
    }
}